import { type ToastAction } from './actions.js';
import * as actionTypes from './actionTypes.js';
import { TOAST_LIMIT } from './constants.js';
import { type Toast } from './types.js';

export type ToastState = {
  pausedAt: number | undefined;
  toasts: Toast[];
};

export const reducer = (state: ToastState, action: ToastAction): ToastState => {
  switch (action.type) {
    case actionTypes.ADD_TOAST: {
      const { toast } = action.payload;

      return {
        ...state,
        toasts: [toast, ...state.toasts].slice(0, TOAST_LIMIT),
      };
    }

    case actionTypes.DISMISS_TOAST: {
      const { payload } = action;

      return {
        ...state,
        toasts: state.toasts.map((toast) => {
          return payload === undefined || payload.toastId === toast.id
            ? { ...toast, visible: false }
            : toast;
        }),
      };
    }

    case actionTypes.END_PAUSE: {
      const { time } = action.payload;

      const diff = time - (state.pausedAt ?? 0);

      return {
        ...state,
        pausedAt: undefined,
        toasts: state.toasts.map((toast) => ({
          ...toast,
          pauseDuration: toast.pauseDuration + diff,
        })),
      };
    }

    case actionTypes.REMOVE_TOAST: {
      const { payload } = action;

      if (payload === undefined) {
        return {
          ...state,
          toasts: [],
        };
      }

      return {
        ...state,
        toasts: state.toasts.filter((toast) => toast.id !== payload.toastId),
      };
    }

    case actionTypes.START_PAUSE: {
      const { time } = action.payload;

      return {
        ...state,
        pausedAt: time,
      };
    }

    case actionTypes.UPDATE_TOAST: {
      const { payload } = action;

      return {
        ...state,
        toasts: state.toasts.map((toast) =>
          toast.id === payload.toast.id
            ? { ...toast, ...payload.toast }
            : toast,
        ),
      };
    }

    case actionTypes.UPSERT_TOAST: {
      const { payload } = action;

      return state.toasts.some((toast) => toast.id === payload.toast.id)
        ? reducer(state, {
            payload,
            type: actionTypes.UPDATE_TOAST,
          })
        : reducer(state, {
            payload,
            type: actionTypes.ADD_TOAST,
          });
    }

    default: {
      return state;
    }
  }
};
